import * as React from "react";

import { Input as UiInput, Label } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/**
 * Input — Textfeld mit optionalem Label.
 *
 * Dünne Hülle um das Primitive `@/components/ui/input`, damit die bestehenden
 * Aufrufer (`label`, `className`, restliche Input-Props) unverändert bleiben.
 * Neuer Code verwendet direkt `<Label>` + `<Input>`.
 */
const Input = ({ label, className, ...props }) => (
  <div className="mt-[0.8rem]">
    {label && <Label>{label}</Label>}
    <UiInput className={cn(className)} {...props} />
  </div>
);

export default Input;
